<template>
  <div class="legal-page">
    <header class="legal-header">
      <router-link to="/" class="legal-brand">
        <span class="legal-brand__logo">G</span>
        Go Trust
      </router-link>
    </header>
    <main class="legal-main">
      <h1>{{ title }}</h1>
      <p class="legal-updated">更新日期：{{ updatedAt }}</p>
      <div class="legal-body" v-html="bodyHtml" />
    </main>
  </div>
</template>

<script>
export default {
  name: 'LegalDocPage',
  props: {
    title: { type: String, required: true },
    updatedAt: { type: String, default: '2026年8月16日' },
    bodyHtml: { type: String, required: true },
  },
}
</script>

<style scoped>
.legal-page {
  min-height: 100vh;
  background: #f3f0ea;
  color: #3d3428;
}
.legal-header {
  background: #3c4e4d;
  height: 52px;
  display: flex;
  align-items: center;
  padding: 0 16px;
}
.legal-brand {
  color: #fff;
  font-weight: 700;
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
}
.legal-brand__logo {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #f17a2b;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
}
.legal-main {
  max-width: 720px;
  margin: 0 auto;
  padding: 24px 16px 48px;
}
.legal-main h1 {
  font-size: 24px;
  font-weight: 800;
  margin-bottom: 8px;
}
.legal-updated {
  font-size: 13px;
  color: #8a7f72;
  margin-bottom: 20px;
}
.legal-body {
  background: #fff;
  border-radius: 14px;
  padding: 20px 16px;
  line-height: 1.75;
  font-size: 14px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}
.legal-body :deep(h2) {
  font-size: 16px;
  margin: 20px 0 8px;
}
.legal-body :deep(h2:first-child) {
  margin-top: 0;
}
.legal-body :deep(p),
.legal-body :deep(li) {
  color: #5c5348;
  margin-bottom: 8px;
}
.legal-body :deep(ul) {
  padding-left: 18px;
  margin: 0 0 8px;
}
</style>
